// src/components/scheduler/SchedulerContext.tsx
import React, { createContext, useContext, useState } from 'react';
import { LeadFormData, AppointmentData } from './types';

interface SchedulerContextType {
    leadData: LeadFormData | null;
    setLeadData: (data: LeadFormData) => void;
    appointmentData: AppointmentData | null;
    setAppointmentData: (data: AppointmentData) => void;
    apiBaseUrl: string;
}

const SchedulerContext = createContext<SchedulerContextType | undefined>(undefined);

export const useScheduler = () => {
    const context = useContext(SchedulerContext);
    if (!context) {
        throw new Error('useScheduler must be used within SchedulerProvider');
    }
    return context;
};

interface SchedulerProviderProps {
    children: React.ReactNode;
    apiBaseUrl: string;
}

export const SchedulerProvider: React.FC<SchedulerProviderProps> = ({
    children,
    apiBaseUrl
}) => {
    const [leadData, setLeadData] = useState<LeadFormData | null>(null);
    const [appointmentData, setAppointmentData] = useState<AppointmentData | null>(null);

    return (
        <SchedulerContext.Provider
            value={{
                leadData,
                setLeadData,
                appointmentData,
                setAppointmentData,
                apiBaseUrl
            }}
        >
            {children}
        </SchedulerContext.Provider>
    );
};